<template>
  <div class="floating-chat-container">
    <div v-if="activeChats.length > 0" class="chat-wrapper d-flex align-items-end">
      <!-- Iterate over active chats and render a chat window for each -->
      <ChatWindow 
        v-for="chat in activeChats" 
        :key="chat.recipient_id" 
        :chat="chat" 
        @close="closeChat(chat.recipient_id)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ChatWindow from "./ChatWindow.vue";

export default {
  name: "FloatingChatContainer",
  components: {
    ChatWindow
  },
  computed: {
    ...mapGetters("metaChat", ["activeChats"])
  },
  methods: {
    ...mapActions("metaChat", ["closeChat", "startPolling", "stopPolling"])
  },
  mounted() {
    this.startPolling();
  },
  beforeUnmount() {
    this.stopPolling();
  }
};
</script>

<style scoped>
.floating-chat-container {
  position: fixed;
  bottom: 0;
  right: 20px;
  z-index: 9999;
  pointer-events: none; /* Let clicks pass through the container itself */
}
.chat-wrapper {
  gap: 15px;
  padding-bottom: 0; /* Chat windows should stick to the bottom edge */
}
.chat-wrapper > * {
  pointer-events: auto; /* Re-enable clicks for the actual chat windows */
}
</style>
